import SignInForm from "../../SignIn";

const Exam = () => {
    return (
        <div>
            <SignInForm />
        </div>
    );
}

export default Exam;